import React from 'react';
import { useContactForm } from '../hooks/use-contact-form';

export const ContactForm = () => {
    const { status, values, onChange, send } = useContactForm();

    return (
        <div className="contact-form">
            <div className="container">
                <form action="#" method="post" onSubmit={send}>
                    {status.info.message ?
                        <div className={`alert alert-${status.info.error ? 'danger' : 'success'}`} role="alert">
                            {status.info.message}
                        </div> :
                        null}
                    <div className="row mb-4">
                        <div className="col col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Full name"
                                name="fullName"
                                value={values.fullName || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                        <div className="col col-md-6">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Email Address"
                                value={values.email || ''}
                                name="email"
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Subject"
                                name="subject"
                                value={values.subject || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col">
                            <textarea
                                className="form-control"
                                placeholder="Your Message"
                                name="message"
                                value={values.message || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-success text-uppercase px-4 py-3">Submit Now</button>
                </form>
            </div>
        </div>
    );
};

export class ContactFormWrapper extends React.Component {

    render() {
        return (
            <ContactForm />
        )
    }
}
